import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderIconFieldFormFieldTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-icon-field.js'

export function renderIconField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string
): string {
  return renderIconFieldFormFieldTemplate({
    indent: indent,
    fieldName: field.name,
    formItemProps: formItemProps(field),
    labelWithDescription: labelWithDescription(formLabel(field, label), hintJSX, `${indent}      `),
    toLowerCase: label.toLowerCase()
  })
}
